module.exports = __webpack_public_path__ + "img/Solar-Space_symbol_7.ea6f78b2.png";